import { create } from "zustand";
import {
  AlertState,
  AlertType,
  TextButtonAlertType,
  ConfirmAlertType,
} from "types/Common";

export const useAlertStore = create<AlertState>((set, get) => ({
  alertStyle: "alert",
  isVisible: false,
  titleMessage: "",
  message: "",
  okButtonText: "",
  okButtonStyle: undefined,
  cancelButtonText: "",
  textButtonText: "",
  contentComponent: undefined,
  marginHorizontal: undefined,
  okOnPress: undefined,
  cancelOnPress: undefined,
  textOnPress: undefined,

  // 알럿 노출 (버튼 한개)
  showAlert: (params: AlertType) => {
    set({
      alertStyle: "alert",
      isVisible: true,
      titleMessage: params.titleMessage,
      message: params.message,
      okButtonText: params.okButtonText ?? "확인",
      okButtonStyle: params.okButtonStyle,
      okOnPress: params.okOnPress,
      contentComponent: params.contentComponent,
      marginHorizontal: params.marginHorizontal,
    });
  },

  // 알럿 노출 (버튼 한개+하단 텍스트 버튼)
  showTextButtonAlert: (params: TextButtonAlertType) => {
    set({
      alertStyle: "textButtonAlert",
      isVisible: true,
      titleMessage: params.titleMessage,
      message: params.message,
      okButtonText: params.okButtonText ?? "확인",
      okButtonStyle: params.okButtonStyle,
      okOnPress: params.okOnPress,
      contentComponent: params.contentComponent,
      marginHorizontal: params.marginHorizontal,
      textButtonText: params.textButtonText ?? "닫기",
      textOnPress: params.textOnPress,
    });
  },

  // 컨펌 알럿 노출 - 버튼 배치: 취소,확인 순
  showConfirmAlert: (params: ConfirmAlertType) => {
    set({
      alertStyle: "confirmAlert",
      isVisible: true,
      titleMessage: params.titleMessage,
      message: params.message,
      okButtonText: params.okButtonText ?? "확인",
      okButtonStyle: params.okButtonStyle,
      okOnPress: params.okOnPress,
      contentComponent: params.contentComponent,
      marginHorizontal: params.marginHorizontal,
      cancelButtonText: params.cancelButtonText ?? "취소",
      cancelOnPress: params.cancelOnPress,
    });
  },

  // 컨펌 알럿 노출 - 버튼 배치: 확인,취소 순
  showReverseConfirmAlert: (params: ConfirmAlertType) => {
    set({
      alertStyle: "reverseConfirmAlert",
      isVisible: true,
      titleMessage: params.titleMessage,
      message: params.message,
      okButtonText: params.okButtonText ?? "확인",
      okButtonStyle: params.okButtonStyle,
      okOnPress: params.okOnPress,
      contentComponent: params.contentComponent,
      marginHorizontal: params.marginHorizontal,
      cancelButtonText: params.cancelButtonText ?? "취소",
      cancelOnPress: params.cancelOnPress,
    });
  },

  // 알럿 숨김
  hideAlert: () => {
    set({ isVisible: false });
  },

  // 확인 버튼 동작 및 알럿 닫기
  okOnPressWithHide: () => {
    const { hideAlert, okOnPress } = get();
    hideAlert && hideAlert();
    okOnPress?.();
  },

  // 취소 버튼 동작 및 알럿 닫기
  cancelOnPressWithHide: () => {
    const { hideAlert, cancelOnPress } = get();
    hideAlert && hideAlert();
    cancelOnPress?.();
  },

  // 하단 텍스트 버튼 동작 및 알럿 닫기
  textOnPressWithHide: () => {
    const { hideAlert, textOnPress } = get();
    hideAlert && hideAlert();
    textOnPress?.();
  },
}));
